<template>
  <b-taglist>
      <b-tag v-for="(tag, i) in listes"
        :key="i"
        :style="{ backgroundColor: tag.couleur }"
        :type="chooseTagType(tag)"
        size="is-small">
        <b-tooltip v-if="!tag.actif"
                   :label="$t('dispositifPublicitaire.tagArchive')"
                   position="is-top"
        >
          {{ tag.libelle }}
        </b-tooltip>
        <span v-else>
          {{ tag.libelle }}
        </span>
      </b-tag>
  </b-taglist>
</template>

<script>

import { chooseTagType } from '@/services/parametrage/tag/tagService';

export default {
  methods: { chooseTagType },
  props: {
    listes: {
      type: Array,
      required: true,
    },
  },
};

</script>
